import { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import MultiplayerLauncher from '@/components/hub/MultiplayerLauncher';
import SingleplayerLauncher from '@/components/hub/SingleplayerLauncher';
import LyocLinks from '@/components/static/LyocLinks';
import LyocTitle from '@/components/static/LyocTitle';
import weightTable from '@/const/weights/bestWeights.json';
import { aiCheck } from '@/lyoc-common/src/controller/ai_controller';
import { controller_game } from '@/lyoc-common/src/controller/game';
import { createCurrPlayer } from '@/lyoc-common/src/interface/currPlayer/factory';
import { createGameManager } from '@/lyoc-common/src/interface/gameManager/factory';
import { GameManager } from '@/lyoc-common/src/interface/gameManager/types';
import { createPlayerInit } from '@/lyoc-common/src/interface/playerInit/factory';
import { createStateChangeEvent } from '@/lyoc-common/src/interface/stateChangeEvent/factory';
import { GameContext } from '@/state/contexts';
import { getLocalKeyForGameId } from '@/util/localGameStorage';
import { logg } from '@/util/logg';

const GameHub = ({ multiplayer }) => {
	const navigate = useNavigate();
	const {
		setCurrPlayer,
		setGameId,
		setInitState,
		setSinglePlayer,
		setStateChangeHistory,
		setStartGameBool,
	}: any = useContext(GameContext);

	const [singlePlayerName, setSinglePlayerName] = useState('You');
	const [singlePlayerColor, setSinglePlayerColor] = useState('yellow');

	const [gameList, setGameList] = useState([]);

	function setSinglePlayerGameState(gameManager: GameManager) {
		setCurrPlayer(gameManager.currPlayerLocal);
		setGameId(gameManager.gameId);
		setInitState(gameManager.gameState);
		setStateChangeHistory(gameManager.stateChangeHistory);
		setStartGameBool(true);
		setSinglePlayer(true);
	}

	async function startTutorialLocal(e) {
		e.preventDefault();
		setSinglePlayer(true);

		const stateChangeEvent = createStateChangeEvent();

		// get latest game_id (from JSON file of games)
		// make mock players

		let gameId = 0;

		for (let i = 0; i < localStorage.length; i++) {
			const key = localStorage.key(i);
			if (key) {
				const value = localStorage.getItem(key);
				logg(`${key}: ${value}`);
			}
			gameId++;
		}

		gameId++; // use next available game

		const localKey = getLocalKeyForGameId(gameId);

		const currPlayerObj = createCurrPlayer(
			singlePlayerColor,
			0,
			'' + gameId,
			singlePlayerName
		);

		let playerId = currPlayerObj.playerId || 0;

		const playerInit = createPlayerInit(
			playerId,
			0,
			gameId,
			currPlayerObj.color,
			currPlayerObj.pname
		);

		if (
			playerInit.pname.toLocaleLowerCase() === 'commas' ||
			playerInit.pname.toLocaleLowerCase() === 'sporp'
		) {
			playerInit.is_admin = true;
		}

		const dummy1 = createPlayerInit(1, 1000001, gameId, 'blue', 'dummy1');

		const dummy2 = createPlayerInit(2, 1000002, gameId, 'green', 'dummy2');

		const players = [playerInit, dummy1, dummy2];

		const gameState = await controller_game.startTutorial(
			gameId,
			players,
			stateChangeEvent
		);

		const stateChangeHistory = [stateChangeEvent];
		const gameManager = createGameManager(
			gameId,
			gameState,
			stateChangeHistory
		);

		gameManager.normalSeasonalWeights = weightTable;

		const playersInGameOrder = gameManager.gameState.playerStateArray;
		for (let i = 0; i < playersInGameOrder.length; i++) {
			if (currPlayerObj.pname === playersInGameOrder[i].username) {
				currPlayerObj.playerId = playersInGameOrder[i].playerId;
			}
		}

		gameManager.currPlayerLocal = currPlayerObj;

		// await aiCheck(gameManager);

		setSinglePlayerGameState(gameManager);

		logg('** post single player game state **');
		logg(gameManager.gameState);
		logg('currPlayerObj');
		logg(currPlayerObj);

		const gameString = JSON.stringify(gameManager);
		localStorage.setItem(localKey, gameString);

		// tutorial through every action and first season, then make it run like a normal game
		// end turn -> next step of tutorial
		// end of tutorial -> start of fall
		// decide an award resolution & turn order
		// if we restart, just go to board3d, not this driver, and pick up game from wherever we're at
		navigate(`/board3dtutorial?gameId=${gameId}&local=true`, {
			replace: true,
		});
	}

	return (
		<>
			<LyocTitle showImg={true} />
			<button className='lyoc-button' onClick={(e) => startTutorialLocal(e)}>
				TUTORIAL
			</button>
			{multiplayer && <MultiplayerLauncher />}
			<SingleplayerLauncher />

			<LyocLinks />
		</>
	);
};

export default GameHub;
